import React from 'react';

function BillingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <g>
        <path
          fill="#FF8A00"
          d="M20 20.417V4.294c0-.552-.464-.994-1.044-.994H5.043C4.463 3.3 4 3.742 4 4.294v16.343c0 .11.116.11.116.221 0 0 0 .11.116.11.116.111.232.111.348.222.116 0 .232.11.348.11.115 0 .231 0 .347-.11.116 0 .116-.11.116-.11s.116 0 .116-.111l1.623-1.436 1.624 1.436c.347.331 1.043.331 1.39 0l1.624-1.436 1.623 1.436c.348.331 1.044.331 1.392 0l1.623-1.436 1.623 1.436s.116 0 .116.11c.116 0 .116.11.232.11H19.073s.115 0 .115-.11c.116 0 .116-.11.232-.11 0 0 0-.11.116-.11 0-.111.116-.111.116-.222.348 0 .348-.11.348-.22zm-4.058-2.872l-1.623 1.436-1.623-1.436c-.348-.33-1.044-.33-1.392 0l-1.623 1.436-1.623-1.436c-.348-.33-1.044-.33-1.391 0l-.58.553V5.288h11.942v12.81l-.58-.553a1.267 1.267 0 00-1.507 0zm.464-9.607c0 .552-.464.994-1.044.994H8.638c-.58 0-1.044-.442-1.044-.994s.464-.994 1.044-.994h6.724c.58 0 1.044.442 1.044.994zm-2.55 3.976c0 .552-.465.993-1.044.993H8.638c-.58 0-1.044-.441-1.044-.993 0-.553.464-.884 1.044-.884h4.174c.58 0 1.043.442 1.043.884z"
        ></path>
      </g>
    </svg>
  );
}

export default BillingIcon;
